import envConfig from '@hulu/env-config';
import { User } from 'mission-control-common-components';

import { sendTokenToWorker } from '../configs/serviceWorkerInit';
import { getCognitoDetailsForSession } from './cognitoDetails';

/** Refreshes the MC idToken and syncs it to the service worker before notification API calls. */
export const getNotificationsAccessToken = async (): Promise<string | null | undefined> => {
  if (envConfig.REACT_APP_AUTH_FEATURE_ENABLED !== 'true') {
    return User.getUserInfo().idToken;
  }

  await User.checkIdToken(undefined, await getCognitoDetailsForSession())
    .then(() => sendTokenToWorker(navigator))
    .catch((error) => {
      console.error(error);
    });

  return User.getUserInfo().idToken;
};
